const $ = jQuery.noConflict();

function scrollFunc(e) {
  const body = $("body");
  const header = $(".main-header:not(.static)");
  const inpageNav = $(".inpage-nav");
  let target = false;

  if (e) {
    e.preventDefault();
    const trigger = $(e.delegateTarget);
    target =
      trigger.attr("href") === "#next"
        ? trigger.parents("section").next()
        : $(trigger.attr("href"));

	const url = new URL(window.location.href);
	const anchor = url.hash ? url.hash.substring(1) : null;

	if (anchor) {
		const escapedAnchor = CSS.escape(anchor);
		const targetSection = document.querySelector(`.block-content#${escapedAnchor}`);

		if (targetSection) {
			targetSection.classList.add('target-removed');
		}
	}
  } else {
    const id = window.location.hash;
    if (id) target = $(id);
  }

  if (target.length) {
    let offset = -1; // one pixel inaccuracy

    offset += inpageNav.length ? inpageNav.outerHeight() : header.outerHeight();

    const mt = parseInt(target.css("margin-top"), 10);
    const pt = parseInt(target.css("padding-top"), 10);
    if (
      e.currentTarget.hash !== "#waystogive" &&
      e.currentTarget.hash !== "#circles" &&
      e.currentTarget.hash !== "#spotlight"
    ) {
      offset += 30;
    }

    body.addClass("smooth-scroll");
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: parseInt(target.offset().top - offset, 10),
        },
        600,
        () => {
          setTimeout(() => {
            body.removeClass("smooth-scroll");
          }, 100);
        }
      );
  }
}

function smoothScroll() {
  $('a[href^="#"]:not([href="#"]):not([href^="#popmake-"])').on(
    "click",
    scrollFunc
  );
  setTimeout(scrollFunc, 100);
}

export default smoothScroll;
